module.exports = __webpack_public_path__ + "img/icon_coordinates6.885c102f.png";